export function currencyFormat(value: number): string {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", currencyDisplay: "narrowSymbol" }).format(+value)
}